<template>
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol class="align-self-center">
          <label class="mb-0 font-lg font-weight-bold">Results</label>
        </CCol>
        <CCol class="text-right" v-if="print">
          <CButton @click="exportPDF" class="mr-2" color="danger" v-c-tooltip="{content: 'Export as PDF file', active:false }"
                   variant="outline">
            <strong>PDF</strong>
          </CButton>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody class="pl-5 pr-5" id="wordDocument">
      <exam-detail :results="results" class="mb-4"/>
      <item-analysis-result :results="results"/>
    </CCardBody>
  </CCard>
</template>

<script>
import ExamDetail from "@/components/document/examDetail";
import ItemAnalysisResult from "@/components/document/itemAnalysisResult";

export default {
  name: "AnalyticReport",
  components: {ItemAnalysisResult, ExamDetail},
  props: {
    results: Object
  },
  data() {
    return {
      print: true
    }
  },
  methods: {
    exportWord() {
      const content = document.getElementById("wordDocument").innerHTML
      let vm = this,
          word = `<html xmlns:o='urn:schemas-microsoft-com:office:office xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Item-Banking System of School of Medicine of Mae Fah Luang University</title></head>
        <body><div>
			<div class="row">
			<hr>
			${content}
			<hr>
			</div>
		</div></body>
		</html>`;
      let source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(word);
      let fileDownload = document.createElement('a');
      document.body.appendChild(fileDownload);
      fileDownload.href = source;
      fileDownload.download = 'document.doc';
      fileDownload.click();
      document.body.removeChild(fileDownload);
    },
    exportPDF() {
      this.print = false
      this.$emit("printPDF")
      setTimeout(() => {
        this.print = true
      }, 2000)
    }
  }
}
</script>
